import { ACCENTS } from "./accents.js";
import { DEFAULT_EVENT_NAME } from "./seed.js";
import { initialState } from "./store.js";
import type { AccentId, DemoBrand, DemoState } from "./types.js";

const NAME_LIMIT = 40;
const DEMO_PATH = "/cerimonialistas/demo/";

function pickedName(params: URLSearchParams): string {
  return (params.get("nome") ?? "").trim().slice(0, NAME_LIMIT);
}

function pickedAccent(params: URLSearchParams): AccentId | undefined {
  const wanted = params.get("cor");
  return ACCENTS.find((option) => option.id === wanted)?.id;
}

export function suggestedBrand(search: string, brand: DemoBrand | null): DemoBrand | null {
  const params = new URLSearchParams(search);
  const name = pickedName(params);
  const accent = pickedAccent(params);
  if (!name && !accent) {
    return brand;
  }
  return {
    name: name || (brand?.name ?? ""),
    accent: accent ?? brand?.accent ?? "green",
    logo: brand?.logo ?? null,
    eventName: brand?.eventName ?? DEFAULT_EVENT_NAME,
  };
}

export function clientBrand(search: string): DemoBrand | null {
  const params = new URLSearchParams(search);
  const name = pickedName(params);
  if (params.get("para") !== "cliente" || !name) {
    return null;
  }
  return {
    name,
    accent: pickedAccent(params) ?? "green",
    logo: null,
    eventName: DEFAULT_EVENT_NAME,
  };
}

export function seededState(search: string, loaded: DemoState | null, now: number): DemoState {
  const brand = clientBrand(search);
  if (!brand) {
    return loaded?.audience === "planner" ? loaded : initialState(now);
  }
  if (
    loaded?.audience === "client" &&
    loaded.brand?.name === brand.name &&
    loaded.brand.accent === brand.accent
  ) {
    return loaded;
  }
  return { ...initialState(now, "client"), brand, guide: { step: "invite", collapsed: false } };
}

function query(name: string, accent: AccentId, extra: Record<string, string> = {}): string {
  const params = new URLSearchParams();
  const trimmed = name.trim().slice(0, NAME_LIMIT);
  if (trimmed) {
    params.set("nome", trimmed);
  }
  params.set("cor", accent);
  for (const [key, value] of Object.entries(extra)) {
    params.set(key, value);
  }
  return params.toString().replace(/\+/g, "%20");
}

export function demoHref(name: string, accent: AccentId): string {
  return `${DEMO_PATH}?${query(name, accent)}#/marca`;
}

export function clientHref(origin: string, brand: DemoBrand): string {
  return `${origin}${DEMO_PATH}?${query(brand.name, brand.accent, { para: "cliente" })}#/inicio`;
}
